import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid, Card, Select, MenuItem } from '@mui/material';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftInput from 'components/SoftInput';
import SoftButton from 'components/SoftButton';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { AutoComplete, CustomSelect } from '../../components/atoms';
import service from '../../api/services';
import IPhoneScreen from '../../../assets/images/iphoneScreen.png'
import AndroidScreen from '../../../assets/images/androidScreen.png'
import Logo from '../../../assets/images/logo.png'
import CustomRecurrenceModal from './CustomRecurrenceModal'
import './style.css'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import FCMTokenDialog from './fcmToken';
import { color } from 'framer-motion';


const PushNotificationForm = () => {
    const [openModal, setOpenModal] = useState(false);
    const [showFCMModal, setShowFCMModal] = useState(false);
    const [dateTime, setDateTime] = useState('');
    const [time, setTime] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [frequencyLimit, setFrequencyLimit] = useState('');
    const [customFrequencyDays, setCustomFrequencyDays] = useState('');
    const [repeatEvery, setRepeatEvery] = useState(1);
    const [unit, setUnit] = useState('WEEKLY');
    const [selectedDays, setSelectedDays] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate()
    const [dropdowns, setDropdowns] = useState({
        country: [], state: [], city: [], subAddline: [],
        zipcode: [],
        userType: [{ label: 'User', value: 'user' }, { label: 'Guest', value: 'guest' }, { label: 'Both', value: 'both' }],
        subscriberType: [{ label: 'Subscriber', value: 'SUBSCRIBED' }, { label: 'Not Subscriber', value: 'UNSUBSCRIBED' },
        { label: 'Both', value: 'BOTH' }],
        appList: [{ label: 'Android', value: 'android' }, { label: 'IOS', value: 'ios' }, { label: 'Both', value: 'both' }],
        scheduleOption: [{ label: 'Now', value: 'now' }, { label: 'Daily', value: 'daily' }, { label: 'Custom', value: 'custom' },
        { label: 'Schedule', value: 'SCHEDULED' }]
    });

    const optionSchema = Yup.object({
        label: Yup.string().required('Label is required'),
        value: Yup.string().required('Value is required'),
    }).required('This field is required');


    const formik = useFormik({
        initialValues: {
            title: '',
            message: '',
            country: [],
            state: [],
            city: [],
            subAddline: [],
            zipcode: [],
            userType: null,
            subscriberType: null,
            app: null,
            schedule: null,
        },
        validationSchema: Yup.object({
            title: Yup.string().required('Title is required'),
            message: Yup.string().required('Message is required'),


            country: Yup.array()
                .of(optionSchema)
                .min(1, 'Country is required')
                .required('Country is required'),
            // state: optionSchema.label('State'),
            // city: optionSchema.label('City'),

            // subAddline: optionSchema.label('subAddline'),

            // zipcode: optionSchema.label('zipCode'),

            userType: optionSchema.label('User type'),
            subscriberType: optionSchema.label('Subscriber type'),
            app: optionSchema.label('App'),
            schedule: optionSchema.label('schedule'),
        }),
        onSubmit: async (values) => {
            const scheduleValue = values?.schedule?.value;
            
            // Validation for SCHEDULED type
            if (scheduleValue === 'SCHEDULED') {
                if (!dateTime) {
                    setError('Please select a valid date and time for scheduling.');
                    toast.error('Please select a valid date and time for scheduling.');
                    return;
                }
                // Validate that scheduled date is in the future
                const scheduledDate = new Date(dateTime);
                const now = new Date();
                if (scheduledDate <= now) {
                    setError('Scheduled date and time must be in the future.');
                    toast.error('Scheduled date and time must be in the future.');
                    return;
                }
            }
            
            // Validation for daily or custom types
            const isDailyOrCustom = scheduleValue === 'daily' || scheduleValue === 'custom';
            if (isDailyOrCustom) {
                if (!time || !frequencyLimit || !startDate || !endDate) {
                    setError('Please fill all required fields for daily/custom notifications.');
                    toast.error('Please fill all required fields for daily/custom notifications.');
                    return;
                }
                if (frequencyLimit === '2' && !customFrequencyDays) {
                    setError('Please enter the custom frequency days.');
                    toast.error('Please enter the custom frequency days.');
                    return;
                }
                // Validate that start date is not in the past
                const start = new Date(startDate);
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                if (start < today) {
                    setError('Start date cannot be in the past.');
                    toast.error('Start date cannot be in the past.');
                    return;
                }
                // Validate that end date is after start date
                const end = new Date(endDate);
                if (end < start) {
                    setError('End date must be after start date.');
                    toast.error('End date must be after start date.');
                    return;
                }
            }
            
            // Clear any previous errors
            setError('');
            
            try {
                let isCustom = values?.schedule.value === 'custom';
                let isDaily = values?.schedule.value === 'daily';
                let isSchedule = values?.schedule.value === 'SCHEDULED';
                let isDailyOrCustom = values?.schedule.value === 'daily' || isCustom;
                let isIOS = values?.app?.value === 'ios';

                let valuesCountry = formik.values.country && formik.values.country.map((item) => item._id)
                let valuesState = formik.values.state && formik.values.state.map((item) => item._id)
                let valuesCity = formik.values.city && formik.values.city.map((item) => item._id)
                let valuesSubAddLine = formik.values.subAddline && formik.values.subAddline.map((item) => item._id || item.value || item)
                let valuesZipcode = formik.values.zipcode && formik.values.zipcode.length > 0 ? formik.values.zipcode.map((item) => item.value) : dropdowns?.zipcode?.map((item) => item.value)

                let payload = {
                    title: values.title,
                    message: values.message,
                    scheduleType: values?.schedule?.value?.toUpperCase(),
                    startDate: (isIOS || isDailyOrCustom) ? startDate : null,
                    scheduleTime: isCustom ? null : isDaily ? null : isSchedule ? dateTime : null,
                    onlyTime: (isCustom || isDaily) ? time : null,
                    endDate: (isIOS || isDailyOrCustom) ? endDate : null,
                    frequencyLimit: isDailyOrCustom ? frequencyLimit : null,
                    customRecurrence: isCustom ? unit : isDaily ? 'DAY' : null,
                    customRecurrenceDays: isCustom && unit == 'DAY' ? repeatEvery : isDaily ? 1 : null,
                    customRecurrenceWeek: isCustom && unit == 'WEEKLY' ? selectedDays : null,
                    targetApp: values?.app?.value?.toUpperCase() || null,
                    userType: values?.userType?.value?.toUpperCase() || null,
                    subscriberType: values?.subscriberType?.value?.toUpperCase() || null,
                    targetAudience: {
                        country: valuesCountry || [],
                        state: valuesState || [],
                        city: valuesCity || [],
                        subAddLine: valuesSubAddLine || [],
                        zipCode: valuesZipcode || []
                    }

                };
                let res = await service.notification.send(localStorage.getItem('id'), payload)

                if ([200, 201].includes(res.status)) {
                    toast.success(res?.data?.message || 'saved successfully.');
                    navigate(-1);
                } else {
                    toast.error(res?.data?.message || 'Failed to save .');
                }
            } catch (error) {
                const errMsg = error?.response?.data?.message || 'Something went wrong while submitting.';
                toast.error(errMsg);
                console.error('Submission error:', error);
            }
        }
    });

    const renderAuto = ({
        label,
        name,
        options,
        isDisabled = false,
        isMultiple = false,
        isRequired = false,
    }) => (
        <SoftBox width="100%">
            <SoftTypography component="label" variant="caption" fontWeight="bold">
                {label}{isRequired && <span style={{ color: 'red' }}>*</span>}
            </SoftTypography>
            <AutoComplete
                name={name}
                multiple={isMultiple}
                value={
                    isMultiple
                        ? formik.values[name] || [] // ensure it's an array
                        : formik.values[name] || null // ensure it's not undefined
                }
                options={options || []}
                onChange={(e, val) => {
                    formik.setFieldValue(name, val);
                }}
                onBlur={() => formik.setFieldTouched(name, true)}
                error={formik.touched[name] && Boolean(formik.errors[name])}
                invalid={formik.touched[name] && Boolean(formik.errors[name])}
                fullWidth
                disabled={isDisabled}
            />
            {formik.touched[name] && formik.errors[name] && (
                <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                    {/* {typeof formik.errors[name] === 'string'
                        ? formik.errors[name]
                        : JSON.stringify(formik.errors[name])} */}
                This field is required
                </SoftTypography>
            )}
        </SoftBox>
    );
    const handleGetCountry = async () => {
        try {
            let res = await service.notification.country({ admin: true });
            if (res?.data?.data) {

                let temp = res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item._id,
                }));
                setDropdowns((prev) => ({ ...prev, country: temp }));
            }
        } catch (error) {
            console.log("error", error);
        }
    };

    const handleGetState = async (countryID) => {
        try {
            let res = await service.notification.state({ countryIds: countryID, admin: true, search: '' });
            if (res?.data?.data) {
                let temp = res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item._id,
                }));
                setDropdowns((prev) => ({ ...prev, state: temp }));
            }
        } catch (error) {
            console.log("error", error);
        }
    };

    const handleGetCity = async (stateName) => {
        try {
            let res = await service.notification.city({ stateNames: stateName }); // Ensure this method is correct
            if (res?.data?.data) {
                let temp = res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.name,
                    value: item._id,
                }));
                setDropdowns((prev) => ({ ...prev, city: temp }));
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    const handleGetZipCode = async ({ cityids, stateIDs, countryIds }) => {
        try {
            let res = await service.notification.zipcode({ cityIds: cityids, stateIDs, countryIds }); // Ensure this method is correct
            if (res?.data?.data) {
                let temp = res?.data?.data?.map((item) => ({
                    ...item,
                    label: item.name || item,
                    value: item._id || item,
                }));
                setDropdowns((prev) => ({ ...prev, zipcode: temp }));
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    const handleGetSubline = async (stateName) => {
        try {
            let res = await service.notification.subAddLines({ stateNames: stateName });
            if (res?.data?.data) {
                let temp = res?.data?.data?.map((item) => ({
                    ...item,
                    label: item,
                    value: item,
                }));
                setDropdowns((prev) => ({ ...prev, subAddline: temp }));
            }
        } catch (error) {
            console.log("error", error);
        }
    };
    useEffect(() => {
        handleGetCountry();
    }, []);

    useEffect(() => {
        if (formik?.values?.country && formik?.values?.country?.length !== 0) {
            formik.setValues({
                ...formik.values,
                state: null,
                city: null,
                subAddline: null,
                zipcode: null,
            })
            let values = formik?.values?.country && formik?.values?.country?.map((item) => item._id)
            
            handleGetState(values);
        }
    }, [formik.values.country]);

    useEffect(() => {
        if (formik?.values?.state && formik?.values?.state?.length !== 0) {
            let values = formik?.values?.state && formik?.values?.state.map((item) => item.label)
            handleGetCity(values);
            handleGetSubline(values);
            
            formik.setValues({
                ...formik.values,
                city: null,
                subAddline: null,
                zipcode: null,
            })
        }
    }, [formik.values.state]);

    useEffect(() => {
        if (formik?.values?.city && formik?.values?.city?.length !== 0) {
            formik.setValues({
                ...formik.values,
                zipcode: null,
            })
            let values = formik?.values?.city && formik?.values?.city.map((item) => item.value)
            handleGetZipCode({ cityids: values, stateIDs: [], countryIds: [] });
        }
    }, [formik.values.city]);

    // useEffect(() => {
    //     if (formik?.values?.state) {
    //         let values = formik?.values?.state && formik?.values?.state.map((item)=>item.label)
    //         handleGetSubline(formik.values.state.label);
    //     }
    // }, [formik.values.state]);

    useEffect(() => {
        if (formik?.values?.schedule?.value === 'custom') {
            setOpenModal(true)
        }
    }, [formik.values.schedule])

    const handleDateTimeChange = (e) => {
        const value = e.target.value;
        setDateTime(value);

        if (!value) {
            setError('Please select a valid date and time for scheduling.');
        } else {
            // Validate that the date is in the future
            const selectedDate = new Date(value);
            const now = new Date();
            if (selectedDate <= now) {
                setError('Scheduled date and time must be in the future.');
            } else {
                setError('');
            }
        }
    };

    const handleStartDateChange = (e) => {
        const value = e.target.value;
        setStartDate(value);
        
        if (value) {
            const start = new Date(value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            if (start < today) {
                setError('Start date cannot be in the past.');
            } else if (endDate && new Date(endDate) < start) {
                setError('End date must be after start date.');
            } else {
                setError('');
            }
        }
    };

    const handleEndDateChange = (e) => {
        const value = e.target.value;
        setEndDate(value);
        
        if (value && startDate) {
            const end = new Date(value);
            const start = new Date(startDate);
            
            if (end < start) {
                setError('End date must be after start date.');
            } else {
                setError('');
            }
        }
    };


    return (
        <>
            <DashboardLayout>
                <DashboardNavbar />
                <SoftBox mt={3} px={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8}>
                            <Card className='glassmorphism-card' sx={{ p: 3 }}>
                                <form onSubmit={formik.handleSubmit}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                Title<span style={{ color: 'red' }}>*</span>
                                            </SoftTypography>
                                            <SoftInput
                                                name="title"
                                                placeholder="Enter Notification Title"
                                                value={formik.values.title}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.title && Boolean(formik.errors.title)}
                                                fullWidth
                                            />
                                            {formik.touched.title && formik.errors.title && (
                                                <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                    {formik.errors.title}
                                                </SoftTypography>
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                Description<span style={{ color: 'red' }}>*</span>
                                            </SoftTypography>
                                            <SoftInput
                                                name="message"
                                                placeholder="Enter Notification Message"
                                                multiline
                                                rows={3}
                                                value={formik.values.message}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.message && Boolean(formik.errors.message)}
                                                fullWidth
                                            />
                                            {formik.touched.message && formik.errors.message && (
                                                <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                    {formik.errors.message}
                                                </SoftTypography>
                                            )}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select Country',
                                                name: 'country',
                                                options: dropdowns.country,
                                                isDisabled: false,
                                                isMultiple: true,
                                                isRequired: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select State',
                                                name: 'state',
                                                options: dropdowns.state,
                                                isDisabled: false,
                                                isMultiple: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select County',
                                                name: 'subAddline',
                                                options: dropdowns.subAddline,
                                                isDisabled: false,
                                                isMultiple: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select City',
                                                name: 'city',
                                                options: dropdowns.city,
                                                isDisabled: false,
                                                isMultiple: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select Zipcode',
                                                name: 'zipcode',
                                                options: dropdowns.zipcode,
                                                isDisabled: false,
                                                isMultiple: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select UserType',
                                                name: 'userType',
                                                options: dropdowns.userType,
                                                isRequired: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select SubscriberType',
                                                name: 'subscriberType',
                                                options: dropdowns.subscriberType,
                                                isRequired: true
                                            })}
                                        </Grid>

                                        <Grid item xs={6}>
                                            {renderAuto({
                                                label: 'Select App',
                                                name: 'app',
                                                options: dropdowns.appList,
                                                isRequired: true
                                            })}
                                        </Grid>

                                        <Grid item xs={12}>
                                            {renderAuto({
                                                label: 'Schedule Notification',
                                                name: 'schedule',
                                                options: dropdowns.scheduleOption,
                                                isRequired: true
                                            })}
                                        </Grid>
                                        {formik?.values?.schedule?.value === 'SCHEDULED' && (
                                            <Grid item xs={12}>
                                                <p style={{ color: 'red', fontSize: '14px' }}>
                                                    Please select a valid date and time for scheduling.
                                                </p>
                                                <SoftTypography variant="subtitle2" sx={{ mb: 1 }}>
                                                    Date and Time<span style={{ color: 'red' }}>*</span>
                                                </SoftTypography>
                                                <SoftInput
                                                    type="datetime-local"
                                                    value={dateTime}
                                                    onChange={handleDateTimeChange}
                                                    error={!!error && (error.includes('Scheduled date') || error.includes('valid date'))}
                                                    placeholder="Select date and time"
                                                />
                                                {error && (error.includes('Scheduled date') || error.includes('valid date')) && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        {error}
                                                    </SoftTypography>
                                                )}
                                                {!dateTime && error && !error.includes('Scheduled date') && !error.includes('valid date') && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        This field is required
                                                    </SoftTypography>
                                                )}
                                            </Grid>
                                        )}
                                        {(formik?.values?.schedule?.value === 'daily' || formik?.values?.schedule?.value === 'custom') && <>
                                            <p style={{ color: 'red', marginLeft: '20px', fontSize: '14px' }}>
                                                Please select time, start date, and end date for daily notifications.
                                            </p>

                                            <Grid item xs={6}>
                                                <SoftTypography variant="caption">Time<span style={{ color: 'red' }}>*</span></SoftTypography>
                                                <SoftInput
                                                    type="time"
                                                    // error={error}
                                                    value={time}
                                                    onChange={(e) => setTime(e.target.value)}
                                                />
                                                {!time && error && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        This field is required
                                                    </SoftTypography>
                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                <SoftTypography variant="caption">Subject to Frequency Limit<span style={{ color: 'red' }}>*</span></SoftTypography>

                                                <SoftBox fullWidth>

                                                    <select
                                                        value={frequencyLimit}
                                                        onChange={(e) => setFrequencyLimit(e.target.value)}
                                                        style={{ width: '100%', padding: '8px', borderRadius: '4px' }} // optional styling
                                                    >
                                                        <option value="" disabled>Select</option>
                                                        <option value="1">Once per user for this message</option>
                                                        <option value="2">Custom</option>
                                                    </select>
                                                    {!frequencyLimit && error && (
                                                        <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                            This field is required
                                                        </SoftTypography>
                                                    )}
                                                </SoftBox>

                                            </Grid>

                                            {frequencyLimit === '2' && (
                                                <Grid item xs={12}>
                                                    <SoftTypography variant="caption">Send no more than one message every<span style={{ color: 'red' }}>*</span></SoftTypography>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <SoftInput
                                                            type="number"
                                                            min="1"
                                                            // error={error}
                                                            value={customFrequencyDays}
                                                            onChange={(e) => setCustomFrequencyDays(e.target.value)}
                                                            placeholder="e.g. 1"
                                                            style={{ width: '80px' }}
                                                        />
                                                        <span>days</span>
                                                    </div>
                                                    {!customFrequencyDays && error && (
                                                        <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                            This field is required
                                                        </SoftTypography>
                                                    )}
                                                </Grid>
                                            )}
                                            <Grid item xs={6}>
                                                <SoftTypography variant="caption">Start Date<span style={{ color: 'red' }}>*</span></SoftTypography>
                                                <SoftInput
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    error={!!error && error.includes('Start date')}
                                                    value={startDate}
                                                    onChange={handleStartDateChange}
                                                />
                                                {error && error.includes('Start date') && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        {error}
                                                    </SoftTypography>
                                                )}
                                                {!startDate && error && !error.includes('Start date') && !error.includes('End date') && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        This field is required
                                                    </SoftTypography>
                                                )}
                                            </Grid>

                                            <Grid item xs={6}>
                                                <SoftTypography variant="caption">End Date<span style={{ color: 'red' }}>*</span></SoftTypography>
                                                <SoftInput
                                                    type="date"
                                                    fullWidth
                                                    size="small"
                                                    error={!!error && error.includes('End date')}
                                                    value={endDate}
                                                    onChange={handleEndDateChange}
                                                />
                                                {error && error.includes('End date') && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        {error}
                                                    </SoftTypography>
                                                )}
                                                {!endDate && error && !error.includes('End date') && !error.includes('Start date') && (
                                                    <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                                        This field is required
                                                    </SoftTypography>
                                                )}
                                            </Grid>
                                        </>}
                                        <Grid item xs={12} display="flex" gap={2}>
                                            <SoftButton type="submit" color="info" variant="gradient">
                                                Send Notification
                                            </SoftButton>
                                            {/* <SoftButton color="secondary" variant="gradient" onClick={() => navigate(-1)}>
                                                Cancel
                                            </SoftButton> */}
                                        </Grid>
                                    </Grid>
                                </form>
                            </Card>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Card className='glassmorphism-card' sx={{ p: 3 }}>
                                <SoftTypography variant="h6">Preview</SoftTypography>
                                <SoftTypography variant="caption" color="text">
                                    This preview gives a general idea of your message's appearance on mobile.
                                </SoftTypography>
                                <SoftBox mt={2}>
                                    <SoftButton color="info" variant="gradient" fullWidth onClick={() => setShowFCMModal(true)}>
                                        Send test message
                                    </SoftButton>
                                </SoftBox>

                                <SoftBox mt={3}>
                                    <div class="android-preview">
                                        <img src={AndroidScreen} alt="Android preview" width="100%" />
                                        <div class="notification-box">
                                            <div class="notification-content">
                                                <h4 id="preview-title-android">{formik.values.title || 'Notification Title'}</h4>
                                                <p id="preview-text-android">{formik.values.message || 'Notification Text'}</p>
                                            </div>
                                            <img id="preview-image-android" src={Logo} alt="Image" class="notification-image" />
                                        </div>
                                    </div>

                                    <SoftTypography align="center">Android</SoftTypography>
                                </SoftBox>
                                <SoftBox mt={3}>
                                    <div class="android-preview">
                                        <img src={IPhoneScreen} alt="Apple preview" width="100%" />
                                        <div class="notification-box">
                                            <div class="notification-content">
                                                <h4 id="preview-title-android">{formik.values.title || 'Notification Title'}</h4>
                                                <p id="preview-text-android">{formik.values.message || 'Notification Text'}</p>
                                            </div>
                                            <img id="preview-image-android" src={Logo} alt="Image" class="notification-image" />
                                        </div>

                                    </div>
                                    <SoftTypography align="center">Apple</SoftTypography>
                                </SoftBox>
                            </Card>
                        </Grid>
                    </Grid>
                </SoftBox>
                <CustomRecurrenceModal
                    repeatEvery={repeatEvery}
                    setRepeatEvery={setRepeatEvery}
                    unit={unit}
                    setUnit={setUnit}
                    selectedDays={selectedDays}
                    setSelectedDays={setSelectedDays}
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    onSave={(data) => {
                        console.log("Recurrence Data", data);
                        setOpenModal(false);
                    }}
                />
                <FCMTokenDialog
                    open={showFCMModal}
                    onClose={() => setShowFCMModal(false)}
                    title={formik.values.title}
                    message={formik.values.message}
                />
            </DashboardLayout>

        </>
    );
};

export default PushNotificationForm;
